<tax-page-header
  [titleText]="retailPlace?.title"
  backButtonUrl="main/kkms"
  [dropdownItems]="dropdownItems"
  [rightSide]="kkmsCounter"
></tax-page-header>
<ng-template #kkmsCounter>
  <span class="kkms-counter" data-qa-block="kkms-count">
    <span class="grey-text" data-qa="kkm-count">{{ retailPlace?.kkms?.length }}/</span>
    <span data-qa="online-kkm-count">{{ retailPlace?.kkmsOnlineCount }}</span>
  </span>
</ng-template>

<div class="status grey-text">
  <span data-qa="retail-place-address">{{ retailPlace?.address }}</span>
  <div>
    <ng-template [ngIf]="retailPlace?.vpnStatus === 1">
      <span translate data-qa="vpn-info"
        >VPN: {{ 'retailPlace.vpn.status.connecting' | translate }}</span
      >
    </ng-template>
    <ng-template [ngIf]="retailPlace?.vpnStatus === 2">
      <span data-qa="vpn-info">VPN ID: {{ retailPlace?.channelId }}</span>
    </ng-template>
    <ng-template [ngIf]="retailPlace?.vpnStatus === 3">
      <span translate data-qa="vpn-info">VPN: {{ 'retailPlace.vpn.status.fail' | translate }}</span>
    </ng-template>
  </div>
</div>

<tax-input
  [(ngModel)]="kkmId"
  placeholder="retail.place.placeholder"
  [autofocus]="true"
  [clearable]="true"
  data-qa-input="search"
></tax-input>

<div
  *ngIf="retailPlace?.kkms?.length"
  class="kkms"
  data-qa="kkms-list"
  (taxElementShow)="scrollToPosition()"
>
  <div *ngFor="let kkm of retailPlace?.kkms; index as i" data-qa="kkk">
    <hr *ngIf="i > 0" />
    <tax-kkm [kkm]="kkm"></tax-kkm>
  </div>
</div>
